module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('main', [_c('h1', [_c('v'), _vm._v("ue GitHub Corners")], 1), _c('p', [_c('octocat'), _vm._v(" "), _c('blank-link', {
    attrs: {
      "url": "https://github.com/tholman/github-corners"
    }
  }, [_vm._v("tholman's GitHub Corners")]), _vm._v(" for "), _c('blank-link', {
    attrs: {
      "url": "https://vuejs.org/"
    }
  }, [_vm._v("Vue")]), _vm._v(".")], 1), _c('p', {
    staticClass: "repo-buttons-container"
  }, [_c('gh-btns-star', {
    attrs: {
      "slug": "gluons/vue-gh-corners",
      "show-count": "show-count"
    }
  }), _c('gh-btns-fork', {
    attrs: {
      "slug": "gluons/vue-gh-corners",
      "show-count": "show-count"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dae2677a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 67
// module chunks = 1